// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".convert-btn-container[data-v-32012338]{width:100%;max-width:572px!important;margin-left:auto;margin-right:auto;padding-bottom:env(safe-area-inset-bottom)}", ""]);
// Exports
module.exports = exports;
